/**
 * @desc 获取帆软报表地址
 */

import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type GetFineURLParameter = {
  filename?: string
}

const method = 'GET'
const url = '/third/fine/getFineURL'

export const getFineURLApi = (
  params?: GetFineURLParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<string>({
    method,
    url,
    params,
    ...config
  })
}

getFineURLApi.method = method
getFineURLApi.url = url
